import { useEffect } from 'react';
import styles from '../../index.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import Pagination from '@navi/web-ui/lib/components/Pagination/Pagination';
import { createQueryParams, readQueryParams } from 'src/utils/QueryParamsHelper';
import { useNavigate } from 'react-router-dom';
import PendingPanApprovalList from './PendingPanApprovalList';
import { EntityType, PENDING_APPROVALS_KEY, initialPaginationParams } from '../../constant';
import { getPendingApprovals } from '../../actions/ApprovalsActions';
import {
  setCurrentSelectedPanIndex,
  setSelectedPanApprovalItem
} from '../../reducers/ApprovalsSlice';

const PanCardApprovals = () => {
  const totalPanPendingApprovals = useSelector(
    (state: RootState) => state.approvals.totalPanPendingApprovals
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { [PENDING_APPROVALS_KEY]: queryParams } = readQueryParams();

  const fetchPanCardApprovals = () => {
    dispatch(
      getPendingApprovals({
        ...initialPaginationParams,
        ...queryParams,
        entityType: EntityType.AGENT_PAN_CARD
      })
    );
  };

  useEffect(() => {
    fetchPanCardApprovals();
    return () => {
      dispatch(setSelectedPanApprovalItem(null));
    };
  }, []);

  const handlePageChange = (page: number) => {
    const params = {
      ...initialPaginationParams,
      ...queryParams,
      page: page.toString(),
      entityType: EntityType.AGENT_PAN_CARD
    };
    const url = createQueryParams({ [PENDING_APPROVALS_KEY]: params });
    navigate(url, {
      replace: true
    });
    dispatch(getPendingApprovals(params));
    dispatch(setSelectedPanApprovalItem(null));
    dispatch(setCurrentSelectedPanIndex(0));
  };

  return (
    <div className={styles.container}>
      <div className={styles.pendingList}>
        <PendingPanApprovalList />
        {totalPanPendingApprovals ? (
          <Pagination
            totalCount={totalPanPendingApprovals}
            hidePageSizeOptions
            onPageChange={handlePageChange}
            currentPage={queryParams?.page ? parseInt(queryParams.page) : 1}
            siblingCount={0}
            hidePageDetails
          />
        ) : null}
      </div>
    </div>
  );
};

export default PanCardApprovals;
